var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:'bs-callout '+_vm.typeClassData},[_c('h4',[_vm._v(_vm._s(_vm.title))]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.sanitizedText(_vm.text))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }